<div class="app-shell">
  @if (allGranted()) {
    <app-order-cancelled-notice />
    <app-cart-update-notice />
    <router-outlet />
  } @else {
    <app-permission-gate />
  }
</div>
